import http from '../../Utils/http';
const AppNotifications = {
    name: 'AppNotifications',
    state: {
        loading: false,
        notifications: [],
        readNotifications: [],
    },
    reducers: {
        AppNotificationsRequested(state) {
            return {
                loading: true,
                notifications: [],
                readNotifications: [],
            };
        },

        AppNotificationsReceived(state, payload) {
            if (payload && Array.isArray(payload?.data?.data)) {
                const AppNotificationss = payload?.data?.data?.map((AppNotifications) => ({
                    id: AppNotifications?.id,
                    camp_id: AppNotifications?.camp_id,
                    created_at: AppNotifications?.createdAt,
                    isRead: AppNotifications?.isRead,
                    isCommentRead: AppNotifications?.isCommentRead,
                    newDisplayReviewed: AppNotifications?.newDisplayReviewed ?? false,
                    display_id: AppNotifications?.display_id ?? AppNotifications?.displayId ?? null,
                    title: AppNotifications?.title,
                    avatar: AppNotifications?.avatar,
                    email: AppNotifications?.email,
                    message: AppNotifications?.message,
                    newTitle: AppNotifications?.newTitle,
                    name: AppNotifications?.name,
                    type: AppNotifications?.type,
                }));
                const readNotifications = AppNotificationss.filter(notification => notification.isRead);
                return {
                    ...state,
                    notifications: AppNotificationss,
                    readNotifications,
                    loading: false,
                };
            }
            return state;
        },

        AppNotificationsRequestFailed(state, payload) {
            return {
                ...state,
                error: payload,
                loading: false,
            };
        },
    },
    effects: (dispatch) => ({
        async getAppNotifications({ user_id, onBehalf, org_id }) {
            try {
                if (!user_id) {
                    return;
                }
                this.AppNotificationsRequested();
                const response = await http.get(`savvy/app-notifications/?user_id=${user_id}&onBehalf=${onBehalf || ''}&org_id=${org_id || ''}`);
                this.AppNotificationsReceived(response);
            } catch (err) {
                // Don't show error for notifications - it's optional
                this.AppNotificationsRequestFailed(err.message || 'Failed to fetch notifications');
            }
        },

        async toggleIsRead({ ids, user_id }) {
            try {
                this.AppNotificationsRequested();
                const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
                const org_id = JSON.parse(localStorage.getItem('userInfo'))?.org_id || null;
                await http.put(`savvy/app-notifications/toggleIsRead?ids=${ids}&user_id=${user_id}&onBehalf=${onBehalf}&org_id=${org_id}`);
                const response = await http.get(`savvy/app-notifications/?user_id=${user_id}&onBehalf=${onBehalf}&org_id=${org_id}`);
                this.AppNotificationsReceived(response);
            } catch (err) {
                this.AppNotificationsRequestFailed(err);
            }
        },

        async toggleIsCommentRead({ ids, user_id }) {
            try {
                this.AppNotificationsRequested();
                const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
                const org_id = JSON.parse(localStorage.getItem('userInfo'))?.org_id || null;
                await http.put(`savvy/app-notifications/toggleIsCommentRead?ids=${ids}&user_id=${user_id}&onBehalf=${onBehalf}&org_id=${org_id}`);
                const response = await http.get(`savvy/app-notifications/?user_id=${user_id}&onBehalf=${onBehalf}&org_id=${org_id}`);
                this.AppNotificationsReceived(response);
            } catch (err) {
                this.AppNotificationsRequestFailed(err);
            }
        },

        async markNewDisplaysReviewed({ user_id, display_id } = {}) {
            try {
                if (!user_id) return;
                this.AppNotificationsRequested();
                const onBehalf = JSON.parse(localStorage.getItem('onBehalfName'));
                const org_id = JSON.parse(localStorage.getItem('userInfo'))?.org_id || null;
                const displayParam = display_id ? `&display_id=${display_id}` : '';
                await http.put(`savvy/app-notifications/mark-new-displays-reviewed?user_id=${user_id}&onBehalf=${onBehalf || ''}&org_id=${org_id || ''}${displayParam}`);
                const response = await http.get(`savvy/app-notifications/?user_id=${user_id}&onBehalf=${onBehalf || ''}&org_id=${org_id || ''}`);
                this.AppNotificationsReceived(response);
            } catch (err) {
                this.AppNotificationsRequestFailed(err);
            }
        },

        async clearImmediately() {
            this.AppNotificationsRequested();
        }
    }),
};

export default AppNotifications;
